import { useTheme } from "next-themes"
import { Toaster as Sonner, toast } from "sonner"

// NOTE: This file requires a ThemeProvider from next-themes to control theme.
// Our app does not currently mount a ThemeProvider globally, so we should
// avoid rendering this Toaster in multiple layouts to prevent duplicate popups.

type ToasterProps = React.ComponentProps<typeof Sonner>

const Toaster = ({ ...props }: ToasterProps) => {
  // Fallback to 'system' if ThemeProvider is not present
  const { theme = "system" } = useTheme()

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-muted-foreground",
          actionButton:
            "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton:
            "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
        },
      }}
      {...props}
    />
  )
}

export { Toaster, toast }
